module.exports = {
  fr: {
    ariaLabel: "Gestion des cookies",
    text: "Nous utilisons des cookies de mesure d'audience et publicitaires (Google Analytics, Google Ads) pour comprendre l'utilisation du site et mesurer l'efficacité de nos campagnes. Vous pouvez accepter ou refuser ces cookies non essentiels à tout moment.",
    accept: "Accepter",
    refuse: "Refuser",
    manage: "Gérer les cookies",
  },
  en: {
    ariaLabel: "Cookie settings",
    text: "We use audience-measurement and advertising cookies (Google Analytics, Google Ads) to understand site usage and measure our campaigns. You can accept or refuse these non-essential cookies at any time.",
    accept: "Accept",
    refuse: "Refuse",
    manage: "Manage cookies",
  },
  ru: {
    ariaLabel: "Настройки cookie",
    text: "Мы используем файлы cookie для аналитики и рекламы (Google Analytics, Google Ads), чтобы понимать использование сайта и измерять эффективность наших кампаний. Вы можете принять или отклонить эти необязательные файлы cookie в любой момент.",
    accept: "Принять",
    refuse: "Отклонить",
    manage: "Управление cookie",
  },
  de: {
    ariaLabel: "Cookie-Einstellungen",
    text: "Wir verwenden Cookies zur Reichweitenmessung und für Werbung (Google Analytics, Google Ads), um die Nutzung der Website zu verstehen und unsere Kampagnen zu messen. Sie können diese nicht notwendigen Cookies jederzeit annehmen oder ablehnen.",
    accept: "Annehmen",
    refuse: "Ablehnen",
    manage: "Cookies verwalten"
  },
  it: {
    ariaLabel: "Impostazioni dei cookie",
    text: "Utilizziamo cookie di misurazione dell'audience e pubblicitari (Google Analytics, Google Ads) per capire come viene utilizzato il sito e misurare le nostre campagne. Puoi accettare o rifiutare questi cookie non essenziali in qualsiasi momento.",
    accept: "Accetta",
    refuse: "Rifiuta",
    manage: "Gestisci i cookie"
  },
  es: {
    ariaLabel: "Configuración de cookies",
    text: "Utilizamos cookies de medición de audiencia y publicitarias (Google Analytics, Google Ads) para entender el uso del sitio y medir nuestras campañas. Puede aceptar o rechazar estas cookies no esenciales en cualquier momento.",
    accept: "Aceptar",
    refuse: "Rechazar",
    manage: "Gestionar las cookies"
  }
};
